// React
import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// FutureLab
import DesktopNavbar from './components/nav/desktop/DesktopNavbar';
import MobileNavBar from './components/nav/mobile/MobileNavbar';
import { useInitNotificationMutation } from './store/api/chatApi';
import useTrackPageView from './utilities/MixpanelTrackers';
import { initializeNavigation } from './utilities/NavigateTo';

// 3rd Party
import Cookies from 'js-cookie';
import queryString from 'query-string';
import { clearPwaToken, getPwaToken } from './utilities/authCookie';

import { messageListener, getFCMToken } from './firebase';

export default function AppChild() {
	const navigate = useNavigate();
	const location = useLocation();
	const [token, setToken] = useState('');
	const [FCMToken, setFCMToken] = useState('');
	const hasInit = useRef(false);
	const [initNotification] = useInitNotificationMutation();

	// to allow the useLocation to be called by wrapping in the parent route
	useTrackPageView();

	// to export the useNavigate function so functional non component are able to route
	initializeNavigation(navigate);

	useEffect(() => {
		getFCMToken(setFCMToken);
	}, []);

	useEffect(() => {
		messageListener().then((message: any) => {
			if (message?.data) {
				console.log(message.data);
			}
		});
	}, []);

	useEffect(() => {
		getFCMToken(setFCMToken);
	}, []);

	useEffect(() => {
		messageListener().then((message: any) => {
			if (message?.data) {
				console.log(message.data);
			}
		});
	}, []);

	useEffect(() => {
		if (!hasInit.current && token && FCMToken) {
			initNotification({
				token: FCMToken,
			})
				.unwrap()
				.then(() => (hasInit.current = true))
				.catch((e) => console.log(e));
		}
	}, [token, FCMToken]);

	useEffect(() => {
		const token = getPwaToken();
		const queryParams = queryString.parse(location.search);
		const originURL: any = queryParams.originURL;
		const isLoginRoute = location.pathname === '/login';

		if (location.key === 'default' && !!!token && !isLoginRoute) {
			// Store the redirectTo in localStorage
			localStorage.setItem('redirectTo', location.pathname);
		}

		if (location.key === 'default' && location.search) {
			localStorage.setItem('originURL', originURL);
		}

		if (!!!token && !isLoginRoute) {
			navigate('/login');
		}

	}, []);

	useEffect(() => {
		const token = getPwaToken();
		setToken(!!token ? token : '');
	}, [location.pathname, location.search]);

	const logout = async () => {
		const logoutUrl = process.env.REACT_APP_B2C_BASE_URL
			? `${process.env.REACT_APP_B2C_BASE_URL}users/logout`
			: '';
		if (logoutUrl) {
			window.location.assign(logoutUrl);
			return;
		}
		clearPwaToken();
		Cookies.remove('token', {
			domain: process.env.REACT_APP_DOMAIN_NAME,
		});
		Cookies.remove('refreshToken', {
			domain: process.env.REACT_APP_DOMAIN_NAME,
		});
		navigate('../login');
	};

	return (
		<>
			<DesktopNavbar logout={logout} token={token} />
			<MobileNavBar logout={logout} token={token} />
			<main className="fixed inset-x-0 bottom-0 top-[60px] flex min-w-0 justify-center overflow-x-hidden overflow-y-auto font-sans">
				<Outlet />
			</main>
		</>
	);
}
